<script lang="ts">
  import OperationsManager from '@lesaffre/operations-manager'
  import Base from '@factry/base'
  import EquipmentManager from '@factry/equipment-manager'
  import MaterialManager from '@factry/material-manager'
  import MPSManager from '@factry/mps-manager'
  import OrderManager from '@factry/order-manager'
</script>

<Base
  options={[
    OperationsManager,
    EquipmentManager,
    MaterialManager,
    OrderManager,
    MPSManager,
  ]}
/>
